import axios, { AxiosError, HeadersDefaults } from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export interface CommonHeaderProperties extends HeadersDefaults {
  Authorization: string;
  account?: string;
  client?: string;
}

export type ErrorType = {
  code: string;
  friend: string;
};

interface ResponseError {
  code: string;
  message: string;
  friend: string;
}

export function parseError(err: any): ResponseError {
  const error = err as AxiosError;

  if (error.response?.data) {
    const dataError = error.response.data as any;
    if (dataError?.message === "Validation failed") {
      const message =
        dataError?.validation?.body?.message ||
        dataError?.validation?.params?.message ||
        dataError?.validation?.query?.message;

      return {
        code: "validation",
        friend: message || "Erro na validação dos campos",
        message: "",
      };
    }

    if (dataError?.message) {
      return {
        code: dataError.code || "",
        message: dataError.message || "",
        friend: dataError.friend || "",
      };
    }

    const errorData = error.response?.data as ResponseError;
    return errorData;
  }

  return {
    code: "",
    message: "",
    friend: "",
  };
}

export const api = axios.create({
//baseURL: "https://8d5679b815e3.ngrok-free.app",
//  headers: {
//    "ngrok-skip-browser-warning": "true",
//  },
  baseURL: API_BASE_URL,
  timeout: 30000,
});

let lastUnauthorizedEventAt = 0;
const UNAUTHORIZED_EVENT_DEBOUNCE_MS = 3000;

// Interceptor para adicionar token automaticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("@backoffice:token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log("[API] Request configurada:", {
      url: config.url,
      method: config.method,
      hasToken: !!token,
    });
    return config;
  },
  (error) => {
    console.error("[API] Erro no interceptor de request:", error);
    return Promise.reject(error);
  }
);

// Interceptor para logs de resposta e tratamento de erros de autenticação
api.interceptors.response.use(
  (response) => {
    console.log("[API] Resposta recebida:", {
      url: response.config.url,
      status: response.status,
      data: response.data,
    });
    return response;
  },
  (error) => {
    console.error("[API] Erro na resposta:", {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
    });

    // Tratar SOMENTE erros de autenticação real.
    // 403 pode ser apenas permissão de recurso (não deve derrubar sessão).
    // Algumas chamadas internas de validação no AuthProvider usam skipUnauthorizedHandler
    // para evitar loop de eventos "unauthorized".
    const skipUnauthorizedHandler = Boolean((error.config as any)?.skipUnauthorizedHandler);
    if (error.response?.status === 401 && !skipUnauthorizedHandler) {
      const now = Date.now();
      const shouldDispatch = now - lastUnauthorizedEventAt > UNAUTHORIZED_EVENT_DEBOUNCE_MS;
      if (shouldDispatch) {
        lastUnauthorizedEventAt = now;
        console.log("[API] ⚠️ 401 de autenticação. Sinalizando logout...");
        window.dispatchEvent(new Event("unauthorized"));
      }
    }

    return Promise.reject(error); // MUITO IMPORTANTE: Deixe o erro continuar
  }
);
